import React from "react";
import { shallow } from "zustand/shallow";

import { type ShareClassDataWithType } from "@hsl/fund-explorer/metaSchemas";

import groupShareClasses from "../lib/groupShareClasses--temp";
import useExplorerStore from "../store/store";

function useGroupedShareClasses(
    shareClasses: string[],
    groupOn?: string,
    flip?: boolean,
    ordering?: string[],
): Record<string, (ShareClassDataWithType & { group: string })[]> {
    const { refinedData, getShareClassById } = useExplorerStore(
        ({ refinedData, getShareClassById }) => ({
            refinedData,
            getShareClassById,
        }),
        shallow,
    );
    const availableShareclasses = shareClasses.filter((sc) =>
        refinedData.shareClasses.includes(sc),
    );
    const groupedShareClasses = React.useMemo(
        () =>
            groupShareClasses(
                availableShareclasses.map(
                    getShareClassById,
                ) as (ShareClassDataWithType & { group: string })[],
                groupOn,
                flip,
                ordering,
            ),
        [availableShareclasses, groupOn, flip, ordering, getShareClassById],
    );
    return groupedShareClasses;
}

export default useGroupedShareClasses;
